import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { UserService } from '../user.service';
import { User } from '../user.model';
import { UserLog } from '../user-log.model';
import { CheckService } from 'src/app/checks/check.service';
import { Observable } from 'rxjs';
import { FormMessage } from 'src/app/ui-design-library/form-message/form-message.model';
import { FormMessageComponent } from 'src/app/ui-design-library/form-message/form-message.component';
import { IconComponent } from 'src/app/ui-design-library/icon/icon.component';
import { AsyncPipe, DatePipe } from '@angular/common';
import { UserItemComponent } from '../user-item/user-item.component';

@Component({
  selector: 'fnsr-user-details',
  standalone: true,
  imports: [FormMessageComponent, IconComponent, AsyncPipe, DatePipe, UserItemComponent],
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss']
})
export class UserDetailsComponent implements OnInit {

  formMessage?: FormMessage;

  public user: User = {
    _id: '',
    profileImageUrl: '',
    role: '',
    isLeader: false,
    email: '',
    username: '',
    password: '',
    firstName: '',
    lastName: '',
  };

  serverResultForAdmin: FormMessage | undefined;

  userLogs: UserLog[] = [];
  namePart$: Observable<any> | undefined

  constructor(
    public userService: UserService,
    public authService: AuthService,
    public checkService: CheckService,
    public route: ActivatedRoute,
    public router: Router
  ) { }

  ngOnInit() {
    this.route.params.subscribe(param => {
      this.getUser(param['id']);
    });
  }

  clickExtractNameFromEmail() {
    this.namePart$ = this.userService.extractNameFromEmail(this.user.email)
  }

  clickUpdateUser(namePart: any) {
    this.updateUser(this.user._id, namePart)
  }

  getUser(id: string): void {
    this.userService.getUser(id).subscribe(
      result => this.user = result,
      err => console.log(err)
    );
  }

  getUserLogsByOwnerId(_id: string): void {
    this.userService.getUserLogsByOwnerId(_id).subscribe(
      result => this.userLogs = result,
      err => console.log(err)
    );
  }

  updateUser(_id: string, namePart: any): void {
    this.userService.updateUser(this.user._id, namePart).subscribe(
      result => {
        console.log(result);
        this.serverResultForAdmin = {
          message: result,
          messageType: 'success'
        };
        this.user = result.result
      },
      (err: Error) => {
        this.serverResultForAdmin = {
          message: err.message,
          messageType: 'error'
        };
        console.log(err);
      }
    );
  }

  deleteUser(): void {
    if (confirm('Möchtest Du diesen Benutzer wirklich löschen?')) {
      this.userService.deleteUser(this.user._id).subscribe(
        result => {
          console.log(result);
          this.router.navigate(['user/list'])
        },
        (err: Error) => console.log(err)
      );
    }
  }
}
